import { Card, Skeleton, SkeletonText } from '~/components';
import { clsx } from '~/styles/utils';

import {
  cardContentStyle,
  cardHeaderStyle,
  cardStyle,
  labelStyle,
  skeletonAvatarStyle,
  skeletonLabelStyle,
  skeletonSpecificationStyle,
  specificationsStyle,
  titleWrapperStyle,
} from './JobPostCard.css';

export const JobPostCardSkeleton = () => {
  return (
    <Skeleton>
      <Card.Root className={cardStyle}>
        <div className={cardContentStyle}>
          <div className={cardHeaderStyle}>
            <div className={skeletonAvatarStyle} />

            <div className={titleWrapperStyle}>
              <SkeletonText fontSize="large" width="70%" />

              <SkeletonText fontSize="small" width="40%" />
            </div>
          </div>

          <div>
            <SkeletonText fontSize="small" />

            <SkeletonText fontSize="small" width="80%" />
          </div>

          <div className={specificationsStyle}>
            {Array.from({ length: 4 }, () => null).map((_, i) => (
              <SkeletonText className={skeletonSpecificationStyle} fontSize="small" key={i} />
            ))}
          </div>
        </div>

        <div className={clsx(labelStyle, skeletonLabelStyle)} />
      </Card.Root>
    </Skeleton>
  );
};
